export default {
    getCategories: { method: 'get', url: 'groups/categories' },
    postCategories: { method: 'post', url: 'groups/categories' },
    updateCategories: { method: 'put', url: 'groups/categories/{id}' },
    deleteCategories: { method: 'delete', url: 'groups/categories/{id}' },
}